export default __webpack_public_path__ + "static/media/330_store05-en-web.11dde151.png";